import React, {useContext} from 'react'
import {Form} from 'react-bootstrap'
import Select from 'react-select'
import {withTranslation} from 'react-i18next'
import {AuditPaneContext} from '../../../../../context/AuditPane'
import {RecurringDetailsContext} from '../../../../../context/Modal/RecurringDetails'
import {AuditModalBarContext} from '../../../../../context/AuditModalBar'
import capitalize from 'lodash/capitalize'

function CustomRecurringPage(props) {
  const {
    recurrence_attributes,
    setRecurrenceAttributes,
    setRecurrence,
    showRecurrence,
    resetRecurringDetails,
  } = useContext(RecurringDetailsContext)
  const paneState = useContext(AuditPaneContext)
  const modalBar = useContext(AuditModalBarContext)
  let optionItems = [
    {label: 'Month', value: 'month'},
    {label: 'Year', value: 'year'},
  ]
  let selectedItems = [
    {
      label: capitalize(recurrence_attributes.duration),
      value: recurrence_attributes.duration,
    },
  ]
  //let durationLabel = recurrence_attributes.duration'

  const {t} = props
  let repeatDurationError, willStopError, auditAppearDaysError
  if (modalBar.errors.length > 0) {
    modalBar.errors.map(err => {
      switch (err.error_field) {
        case 'repeat_duration':
          repeatDurationError = err
          break
        case 'will_stop_times':
          willStopError = err
          break
        case 'audit_appear_days':
          auditAppearDaysError = err
          break
        default:
          break
      }
      return true
    })
  }

  const handleChange = () => {
    setRecurrence(!showRecurrence)
    if (showRecurrence) {
      resetRecurringDetails()
    } else {
      setRecurrenceAttributes({
        ...recurrence_attributes,
        status: !recurrence_attributes.status,
      })
    }
  }

  return (
    <div className="recurring-input">
      <div className="rec-border">
        <span className="label-color-size">Recurring</span>
        <Form.Check
          type="switch"
          id="custom-switch1"
          className="ap-toggle"
          label=""
          name="status"
          onChange={() => handleChange()}
          checked={showRecurrence}
        />
      </div>
      <div className="mt-7">
        {!showRecurrence ? (
          <span className="label-color-size-2">
            {t('audit.form-custom-recurring-page.does-not-repeat')}
          </span>
        ) : (
          <span className="label-color-size-2">
            Repeats every{' '}
            {recurrence_attributes.frequency === 0 ? '' : recurrence_attributes.frequency}{' '}
            {recurrence_attributes.duration}
            {recurrence_attributes.willStop !== 'Never'
              ? '; ' + recurrence_attributes.occurrences + ' times;'
              : ' '}
          </span>
        )}
      </div>
      {showRecurrence && (
        <div className="mt-16">
          <div className="row col-10 padding-right-0  mt-6">
            <div className="col-3 padding-right-0 padding-left-0 mr--10">
              <input
                className="form-control height-100 input-padding-0 padding-0-13"
                type="Number"
                name="frequency"
                onChange={e =>
                  setRecurrenceAttributes({...recurrence_attributes, frequency: e.target.value})
                }
                value={recurrence_attributes.frequency}
              />
            </div>
            <div className="col-7 padding-right-0 pl-10 padding-left-8">
              <Select
                className="basic-single"
                classNamePrefix="select"
                name="duration"
                isSearchable={true}
                placeholder="month"
                options={optionItems}
                onChange={e =>
                  setRecurrenceAttributes({...recurrence_attributes, duration: e.value})
                }
                value={selectedItems}
                defaultValue="month"
              />
            </div>
            {repeatDurationError && (
              <div className="text-danger">{repeatDurationError.error_message}</div>
            )}
          </div>
          <div className="row col-10 padding-right-0 mt-6">
            <div
              className="padding-right-0 padding-left-0"
              style={{paddingTop: '5px', color: '#585a5d'}}
            >
              Stops
            </div>
          </div>
          <div className="styled_radio">
            <div className="row col-10 padding-right-0 mt-6">
              <div className="col-1 padding-right-0 padding-left-0" style={{color: '#585a5d'}}>
                <input
                  className={
                    recurrence_attributes.willStop === 'Never'
                      ? 'form-control height-65 input-padding-9 checked'
                      : 'form-control height-65 input-padding-9'
                  }
                  value="Never"
                  name="willStop"
                  type="radio"
                  onChange={e =>
                    setRecurrenceAttributes({...recurrence_attributes, willStop: e.target.value})
                  }
                  checked={recurrence_attributes.willStop === 'Never'}
                />
              </div>
              <div
                className={
                  paneState.modalFor === 'Schedule'
                    ? 'col-2 padding-right-0 padding-left-8'
                    : 'col-2 padding-right-0 padding-left-6'
                }
                style={
                  recurrence_attributes.willStop === 'Never'
                    ? {color: '#585a5d'}
                    : {color: 'darkgrey'}
                }
              >
                Never
              </div>
            </div>
            <div
              className={
                paneState.modalFor === 'Schedule'
                  ? 'row col-12 padding-right-0'
                  : 'row col-10 padding-right-0'
              }
            >
              <div className="col-1 padding-right-0 padding-left-0">
                <input
                  className={
                    recurrence_attributes.willStop === 'After'
                      ? 'form-control height-65 input-padding-9 mt-6 checked'
                      : 'form-control height-65 input-padding-9 mt-6'
                  }
                  value="After"
                  name="willStop"
                  type="radio"
                  onChange={e =>
                    setRecurrenceAttributes({...recurrence_attributes, willStop: e.target.value})
                  }
                  checked={recurrence_attributes.willStop === 'After'}
                />
              </div>
              <div
                className="col-2 padding-right-0 padding-left-6 padding-top-10"
                style={
                  recurrence_attributes.willStop === 'After'
                    ? {paddingTop: '5px', color: '#585a5d'}
                    : {paddingTop: '5px', color: 'darkgrey'}
                }
              >
                After
              </div>
              <div className="col-2 input-padding">
                <input
                  className="form-control height-100 input-padding-0 padding-0-13 mt--1"
                  disabled={recurrence_attributes.willStop === 'Never'}
                  type="Number"
                  name="occurrences"
                  onChange={e =>
                    setRecurrenceAttributes({
                      ...recurrence_attributes,
                      occurrences: e.target.value,
                    })
                  }
                  value={recurrence_attributes.occurrences}
                />
              </div>
              <div
                className="col-4 padding-right-0 padding-left-6 padding-top-10 ml-16"
                style={
                  recurrence_attributes.willStop === 'After'
                    ? {paddingTop: '5px', paddingLeft: '2px', color: '#585a5d'}
                    : {paddingTop: '5px', paddingLeft: '2px', color: 'darkgrey'}
                }
              >
                occurrences
              </div>
            </div>
            {recurrence_attributes.willStop === 'After' && willStopError && (
              <div className="text-danger">{willStopError.error_message}</div>
            )}
          </div>
          <div className="row col-10 padding-right-0 mt-6">
            <div
              className="padding-right-0 padding-left-0"
              style={{paddingTop: '5px', color: '#585a5d'}}
            >
              Audits will appear
            </div>
          </div>
          <div className="col-12 row">
            <input
              className="form-control height-100 input-padding-0 padding-0-13"
              type="number"
              name="audit_appear_days"
              style={{padding: '0 4px', textAlign: 'center'}}
              onChange={e =>
                setRecurrenceAttributes({
                  ...recurrence_attributes,
                  audit_appear_days: e.target.value,
                })
              }
              value={recurrence_attributes.audit_appear_days}
              defaultValue={recurrence_attributes.audit_appear_days}
              required
            />
            <span className="col-10" style={{paddingTop: '5px', color: '#585a5d'}}>
              days before start date
            </span>
            {auditAppearDaysError && (
              <div className="text-danger">{auditAppearDaysError.error_message}</div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default withTranslation()(CustomRecurringPage)
